// ReadIndividualArticle.jsx

import { Container, Box, makeStyles } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Helmet } from "react-helmet";
import { PageBanner } from "../../components";
import { backend } from "../../api";
import { useParams } from "react-router";
import CustomPDFViewer from "../../components/CustomPDFViewer/CustomPDFViewer";
import "../ReadArticle/article.css";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  headingsContainer: {
    textAlign: "center",
    margin: "100px 0",
    color: theme.palette.secondary.light,
  },
  infoContainer: {
    textAlign: "justify",
    margin: "70px 0",
    color: theme.palette.secondary.light,
  },
  sectionHeading: {
    fontSize: "64px",
    color: theme.palette.secondary.light,
    fontWeight: 700,
    letterSpacing: 0.1,
    margin: "0 20px",
    lineHeight: "60px",
    [theme.breakpoints.down("md")]: {
      fontSize: "54px",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "45px",
      lineHeight: "40px",
      marginTop: "30px",
    },
  },
}));

function ReadIndividualArticle() {
  const classes = useStyles();
  const [currentArticle, setCurrentArticle] = useState();
  const { directoryId, articleId } = useParams();

  useEffect(() => {
    fetchCurrentArticle();
  }, [directoryId, articleId]);

  const fetchCurrentArticle = () => {
    backend
      .get(`/directory/${directoryId}/article/${articleId}`)
      .then((res) => {
        setCurrentArticle(res.data.data);
      })
      .catch((err) => {
        toast.error(err.response ? err.response.data.message : err.message);
      });
  };

  return (
    <Fragment>
      <Helmet>
        <title> E-Article Reading Zone</title>
      </Helmet>
      <PageBanner
        title="E-Article Reading Zone"
        image="/assets/images/bg4.jpg"
      />
      <div className={classes.headingsContainer}>
        <h6 style={{ fontWeight: 400, fontSize: "14px", letterSpacing: 5 }}>
          Enjoy Your Article
        </h6>
        <h2 className={classes.sectionHeading}> Decade 2 Publishing</h2>
      </div>

      <Container>
        <Box my={5}>
          {currentArticle ? (
            <Box>
              <div className={classes.infoContainer}>
                <h6
                  style={{
                    fontWeight: 500,
                    fontSize: "13px",
                    letterSpacing: 3,
                  }}
                >
                  Article Title : {currentArticle.article_title}
                </h6>
                <h6
                  style={{
                    fontWeight: 500,
                    fontSize: "13px",
                    letterSpacing: 3,
                  }}
                >
                  Article Author : d2p
                </h6>
              </div>
              <CustomPDFViewer url={currentArticle.pdf_file} bookId={articleId} />
            </Box>
          ) : (
            <Box>
              <Skeleton animation="wave" />
            </Box>
          )}
        </Box>
      </Container>
    </Fragment>
  );
}

export default ReadIndividualArticle;
